import { Col, Form, Row } from 'antd';
import { RuleObject } from 'antd/es/form';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputTextArea from 'components/atoms/InputTextArea';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context, IDokmentyContext } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import PrilohyTable from 'components/molecules/Dokumenty/PrilohyTable';
import FormWrapper from 'components/molecules/FormWrapper';

import {
    ETypPrikazuDuvod,
    EZpusobPodani,
    IZruseniPrikaz,
    PrikazZruseniGet,
    PrikazZruseniPut
} from 'services/dokumenty/prikazy';
import { ISmlouvniStrany } from 'services/dokumenty/smlouva';

import { EEvidenceCp } from 'enums/isin/evidenceCp';

import { duvodZruseniSelect } from 'data/codebooks/dokumenty/duvodZruseniSelect';
import { evidenceCpSelectEdit } from 'data/codebooks/emise/evidenceCpSelect';
import trueFalseSelect from 'data/codebooks/trueFalseSelect';

import { validateICO } from 'utils/validations/icoValidation';
import { validateLEI } from 'utils/validations/leiValidation';

import { isIsinDlt } from '../NovyDokument';

export const getDataIsins = (docsData: IDokmentyContext | null) => {
    const prikazData = (docsData?.dokumentyPrava?.prikazy || []).filter(
        e => e.typprikazu === (docsData?.selectedZadost?.podtyp! as any)
    );
    return prikazData.length && prikazData[0].emise ? prikazData[0].emise : [];
};

interface IPrikazZruseni {
    nextStep: () => void;
    zadostID: number;
    prikazyData: ISmlouvniStrany;
}

const PrikazZruseni: React.FC<IPrikazZruseni> = ({ nextStep, zadostID, prikazyData }) => {
    const { dokumenty } = useContext(Context);
    const [form] = Form.useForm();
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [isChecked2, setIsChecked2] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [, rerender] = useState<boolean>(false);
    const [data, setData] = useState<IZruseniPrikaz>();
    const [dataIsins] = useState<
        {
            labelcz: string;
            value: string;
        }[]
    >(
        getDataIsins(dokumenty).map(e => {
            return {
                labelcz: e.isin,
                value: e.isin
            };
        }) || []
    );

    const [selectedIsin, setSelectIsin] = useState<string>();
    const [isDLT, setIsDLT] = useState<boolean>();
    useEffect(() => {
        if (selectedIsin) {
            setIsDLT(isIsinDlt(selectedIsin, dokumenty!));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIsin]);

    useEffect(() => {
        setLoading(true);
        PrikazZruseniGet(zadostID)
            .then(resp => {
                setSelectIsin(resp.isin);
                setData(resp);
                setIsChecked(!!resp.isin);
                form.setFieldsValue({
                    vypis: resp.isin ? true : false,
                    typzpusob: resp.typzpusob
                });
                /*  form.setFieldsValue({
                    znazev: resp.znazev,
                    zadresa: resp.zadresa,
                    zemailfakt: resp.zemailfakt,
                    zemailpopl: resp.zemailpopl,
                    zjina: resp.zjina
                }); */
            })
            .catch(() => setData({} as IZruseniPrikaz))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostID]);

    return (
        <LoadingWrapper loading={loading}>
            {data && prikazyData && (
                <>
                    <FormWrapper
                        outForm={form}
                        onFinish={values => {
                            setLoading(true);
                            const dataToSend = {
                                ...(values as any),
                                datum: values.datum.format('YYYY-MM-DD'),
                                ...(values.kedni && {
                                    kedni: values.kedni.format('YYYY-MM-DD')
                                }),
                                ...(typeof values.blokace === 'boolean' && {
                                    blokace: String(values.blokace)
                                }),
                                ...(typeof values.potvrlikv === 'boolean' && {
                                    potvrlikv: String(values.potvrlikv)
                                })
                            };
                            delete dataToSend.idmbSpolecnost;
                            delete dataToSend.dicdphSpolecnost;
                            delete dataToSend.nazevSpolecnost;
                            delete dataToSend.leiSpolecnost;
                            PrikazZruseniPut(zadostID, dataToSend)
                                .then(() => nextStep())
                                .finally(() => setLoading(false));
                        }}
                    >
                        <Title text="EMITENT" level={5} />
                        <InputComponent
                            disabled={true}
                            initialValue={prikazyData?.spolecnost.idmb}
                            label="IDENTIFIKACNI_CISLO"
                            name="idmbSpolecnost"
                            notRequired={true}
                        />
                        {prikazyData?.spolecnost.dicdph && (
                            <InputComponent
                                disabled={true}
                                initialValue={prikazyData?.spolecnost.dicdph}
                                label="ISIN_IDENTIFIKACE_DIC"
                                name="dicdphSpolecnost"
                                notRequired={true}
                            />
                        )}
                        <InputComponent
                            disabled={true}
                            initialValue={prikazyData?.spolecnost.nazev}
                            label="ISIN_IDENTIFIKACE_FIRMA"
                            name="nazevSpolecnost"
                            notRequired={true}
                        />
                        <InputComponent
                            disabled={true}
                            initialValue={prikazyData?.spolecnost.lei}
                            label="LEI_CELE"
                            name="leiSpolecnost"
                            notRequired={true}
                        />
                        <SelectComponent
                            name="isin"
                            labelParagraph={'PRIKAZ_ZNIZENI_ISIN'}
                            defaultValue={data?.isin}
                            data={dataIsins}
                            isFormItem={true}
                            onChange={val => setSelectIsin(val)}
                        />
                        <DatePickerComponent
                            name="datum"
                            initialValue={data?.datum ? dayjs(data.datum) : undefined}
                            //  disabledDate={current => current < dayjs().add(6, 'days')}
                            label="PRIKAZ_PREVOD_DATUM"
                            infoTooltipText="PRIKAZ_ZRUSENI_DATE_TOOLTIP"
                            onChange={val =>
                                form.setFieldsValue({
                                    kedni: val.subtract(1, 'day')
                                })
                            }
                        />
                        <SelectComponent
                            name="typduvod"
                            labelParagraph="PRIKAZ_ZRUSENI_DUVOD"
                            isFormItem={true}
                            data={duvodZruseniSelect}
                            defaultValue={data?.typduvod}
                            onChange={() => rerender(pv => !pv)}
                        />
                        {form.getFieldValue('typduvod') === ETypPrikazuDuvod.PREDSPL && (
                            <InputTextArea
                                rows={4}
                                name="clanek"
                                initialValue={data?.clanek}
                                label="PRIKAZ_ZRUSENI_CLANEKDOK"
                            />
                        )}
                        {form.getFieldValue('typduvod') === ETypPrikazuDuvod.ZMENOSOBA && (
                            <>
                                <SelectComponent
                                    name="osobap"
                                    labelParagraph={'PRIKAZ_ZRUSENI_OSOBA_STARA'}
                                    defaultValue={data?.osobap}
                                    data={evidenceCpSelectEdit}
                                    isFormItem={true}
                                    onChange={() => rerender(pv => !pv)}
                                />
                                {form.getFieldValue('osobap') === EEvidenceCp.JINY && (
                                    <>
                                        <InputComponent
                                            label="PRIKAZ_ZRUSENI_PRIDELENI_OSOBA_PUV_JINY_ICOLEI"
                                            name="jinaosobap"
                                            initialValue={data?.jinaosobap}
                                            type="text"
                                            maxLength={20}
                                            rules={[
                                                () => ({
                                                    async validator(_rule: RuleObject, value: string) {
                                                        if (
                                                            validateLEI(value) === 0 ||
                                                            validateICO(value) === 0 ||
                                                            !value
                                                        )
                                                            return Promise.resolve();
                                                        return Promise.reject(
                                                            <TranslateText>
                                                                {value.length > 8 ? 'NEVALIDNI_LEI' : 'NEVALIDNI_ICO'}
                                                            </TranslateText>
                                                        );
                                                    }
                                                })
                                            ]}
                                        />
                                        {/* <InputComponent
                                            label="ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY"
                                            name="jinaosobap"
                                            //  initialValue={udajeEmise?.jinaosoba}
                                            type="text"
                                            maxLength={500}
                                        />*/}
                                    </>
                                )}
                                <SelectComponent
                                    name="osoban"
                                    labelParagraph={'PRIKAZ_ZRUSENI_OSOBA_NOVA'}
                                    defaultValue={data?.osoban}
                                    data={evidenceCpSelectEdit}
                                    isFormItem={true}
                                    onChange={() => rerender(pv => !pv)}
                                />
                                {form.getFieldValue('osoban') === EEvidenceCp.JINY && (
                                    <>
                                        <InputComponent
                                            label="PRIKAZ_ZRUSENI_PRIDELENI_OSOBA_NOVY_JINY_ICOLEI"
                                            name="jinaosoban"
                                            initialValue={data?.jinaosoban}
                                            type="text"
                                            maxLength={20}
                                            rules={[
                                                () => ({
                                                    async validator(_rule: RuleObject, value: string) {
                                                        if (
                                                            validateLEI(value) === 0 ||
                                                            validateICO(value) === 0 ||
                                                            !value
                                                        )
                                                            return Promise.resolve();
                                                        return Promise.reject(
                                                            <TranslateText>
                                                                {value.length > 8 ? 'NEVALIDNI_LEI' : 'NEVALIDNI_ICO'}
                                                            </TranslateText>
                                                        );
                                                    }
                                                })
                                            ]}
                                        />
                                        {/* <InputComponent
                                            label="ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY"
                                            name="jinaosoban"
                                            //  initialValue={udajeEmise?.jinaosoba}
                                            type="text"
                                            maxLength={500}
                                        />*/}
                                    </>
                                )}
                            </>
                        )}
                        {form.getFieldValue('typduvod') === ETypPrikazuDuvod.JINY && (
                            <InputTextArea
                                rows={4}
                                name="popisduvod"
                                initialValue={data?.popisduvod}
                                label="PRIKAZ_ZRUSENI_DUVOD_INPUT"
                            />
                        )}
                        <SelectComponent
                            name="typzpusob"
                            labelParagraph="PRIKAZ_ZPUSOB_PODANI"
                            isFormItem={true}
                            data={[
                                /*  {
                                    value: EZpusobPodani.CDCP,
                                    labelcz: 'PRIKAZ_ZPUSOB_PODANI_CDCP'
                                }, */
                                {
                                    value: EZpusobPodani.MD,
                                    labelcz: 'PRIKAZ_ZPUSOB_PODANI_MD'
                                },
                                {
                                    value: EZpusobPodani.NEPOZADUJE,
                                    labelcz: 'PRIKAZ_ZPUSOB_PODANI_NEPOZADUJE'
                                }
                            ]}
                            defaultValue={data?.typzpusob}
                            onChange={() => rerender(pv => !pv)}
                        />
                        {/* form.getFieldValue('typzpusob') === EZpusobPodani.CDCP && (
                            <SelectComponent
                                name="typkedni"
                                labelParagraph="PRIKAZ_ZRUSENI_VYPIS_DATUM"
                                isFormItem={true}
                                data={[
                                    {
                                        value: 'PRED',
                                        labelcz: 'PRIKAZ_ZRUSENI_VYPIS_DATUM_PRED'
                                    },
                                    {
                                        value: 'JINY',
                                        labelcz: 'PRIKAZ_ZRUSENI_VYPIS_DATUM_JINY'
                                    }
                                ]}
                                defaultValue={data?.typkedni}
                                onChange={val => {
                                    rerender(pv => !pv);

                                    form.setFieldsValue({
                                        kedni:
                                            val === 'PRED'
                                                ? dayjs(form.getFieldValue('datum').subtract(1, 'days'))
                                                : undefined
                                    });
                                }}
                            />
                        )*/}
                        {/* form.getFieldValue('typzpusob') === EZpusobPodani.CDCP && form.getFieldValue('typkedni') && (
                            <DatePickerComponent
                                name="kedni"
                                disabled={form.getFieldValue('typkedni') === 'PRED'}
                                initialValue={data?.kedni ? dayjs(data.kedni) : undefined}
                               //  disabledDate={current => {
                              //      if (form.getFieldValue('typkedni') === 'JINY') {
                              //          return (
                                //            current < form.getFieldValue('datum') ||
                                //            current > form.getFieldValue('datum').add(30, 'days')
                                //        );
                                //    }
                                //    return false;
                               // }} 
                            />
                        ) */}
                        {form.getFieldValue('typkedni') === 'JINY' && (
                            <SelectComponent
                                name="blokace"
                                labelParagraph="PRIKAZ_ZRUSENI_ZADA_O_VYPIS"
                                isFormItem={true}
                                data={trueFalseSelect}
                                defaultValue={typeof data?.blokace === 'boolean' ? String(data?.blokace) : undefined}
                                onChange={() => rerender(pv => !pv)}
                            />
                        )}
                        {form.getFieldValue('typzpusob') !== EZpusobPodani.NEPOZADUJE && (
                            <Row>
                                <CheckboxComponent
                                    name="vypis"
                                    checkboxText={
                                        <Row>
                                            <Paragraph
                                                text="*"
                                                style={{
                                                    color: '#ff4d4f',
                                                    fontSize: 25,
                                                    position: 'relative',
                                                    top: 4,
                                                    marginRight: 2
                                                }}
                                            />
                                            <Title level={4} text="PRIKAZ_ZRUSENI_CHECKBOX" />
                                        </Row>
                                    }
                                    onChange={() => setIsChecked(pv => !pv)}
                                    defaultChecked={isChecked}
                                    checked={isChecked}
                                    style={{
                                        marginBottom: 4,
                                        marginTop: 10
                                    }}
                                />
                            </Row>
                        )}
                        {form.getFieldValue('typduvod') === ETypPrikazuDuvod.LIKVIDACE && (
                            <SelectComponent
                                name="potvrlikv"
                                labelParagraph="PRIKAZ_ZRUSENI_POTVRZENI"
                                isFormItem={true}
                                data={trueFalseSelect}
                                notRequired={true}
                                defaultValue={
                                    typeof data?.potvrlikv === 'boolean' ? String(data?.potvrlikv) : undefined
                                }
                            />
                        )}
                        <PrilohyTable zadostID={zadostID} required={true} />
                        <Title level={5} text="PRIKAZ_ZRUSENI_INFO_TITLE" />
                        <Paragraph
                            text={isDLT ? 'PRIKAZ_ZRUSENI_INFO_DLT_TEXT1' : 'PRIKAZ_ZRUSENI_INFO_TEXT1'}
                            style={{
                                display: 'block',
                                marginTop: 10,
                                marginBottom: 10
                            }}
                        />
                        <Paragraph
                            text={isDLT ? 'PRIKAZ_ZRUSENI_INFO_DLT_TEXT3' : 'PRIKAZ_ZRUSENI_INFO_TEXT3'}
                            style={{
                                display: 'block',
                                marginTop: 10,
                                marginBottom: 10
                            }}
                        />
                        <Paragraph
                            text={isDLT ? 'PRIKAZ_ZRUSENI_INFO_DLT_TEXT4' : 'PRIKAZ_ZRUSENI_INFO_TEXT4'}
                            style={{
                                display: 'block',
                                marginTop: 10,
                                marginBottom: 10
                            }}
                        />
                        <Paragraph
                            text={isDLT ? 'PRIKAZ_ZRUSENI_INFO_DLT_TEXT5' : 'PRIKAZ_ZRUSENI_INFO_TEXT5'}
                            style={{
                                display: 'block',
                                marginTop: 10,
                                marginBottom: 10
                            }}
                        />
                        <Row
                            style={{
                                marginTop: 26
                            }}
                        >
                            <CheckboxComponent
                                name="souhlas"
                                checkboxText={<TranslateText>POTVRZENI_CHECKBOX</TranslateText>}
                                onChange={() => setIsChecked2(pv => !pv)}
                                checked={isChecked2}
                            />
                        </Row>
                        <Row className="button-row">
                            <Col>
                                <ButtonComponent
                                    buttontext="POKRACOVAT"
                                    id="isinPokracovatBtn"
                                    disabled={
                                        (!isChecked && form.getFieldValue('typzpusob') !== EZpusobPodani.NEPOZADUJE) ||
                                        !isChecked2
                                    }
                                    htmlType="submit"
                                />
                            </Col>
                        </Row>
                    </FormWrapper>
                </>
            )}
        </LoadingWrapper>
    );
};

export default PrikazZruseni;
